import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
const MedicalHistory = () => {
  const validationSchema = Yup.object().shape({
    explanation: Yup.string().required("Explanation is required"),
  });
  const history = useHistory();

  const initialValues = {
    headInjury: "No",
    explanation: "",
    diagnosed: "No",
    diagnosedDisability: "No",
    diagnosedADHD: "No",
    diagnosedDepression: "No",
  };

  const handleSubmit = (values) => {
    console.log("Form Values:", values);
    // alert(JSON.stringify(values, null, 2));
    history.push("/concussion-forms/add/6");
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <span className="form-title">Medical History</span>
        <span className="form-progress">5/12</span>
      </div>

      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isSubmitting }) => (
          <Form className="form-wrapper">
            <div className="form-content">
              <div className="field-wrapper">
                <label className="field-label">
                  Have you been hospitalized for a head injury?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="headInjury">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("headInjury", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="headInjury"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">Explain</label>
                <Field
                  name="explanation"
                  className="field-input notes"
                  as="textarea"
                />
                <ErrorMessage
                  name="explanation"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">
                  Diagnosed/Treated for headache disorders?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="diagnosed">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("diagnosed", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="diagnosed"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">
                  Diagnosed with a learning disability?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="diagnosedDisability">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("diagnosedDisability", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="diagnosedDisability"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">Diagnosed with ADHD?</label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="diagnosedADHD">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("diagnosedADHD", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="diagnosedADHD"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">
                  Diagnosed with depression, anxiety or other psychological
                  disorder?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="diagnosedDepression">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("diagnosedDepression", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="diagnosedDepression"
                  component="div"
                  className="error-message"
                />
              </div>
            </div>
            <div className="btn-wrapper">
              <button
                type="button"
                className="form-btns back-btn"
                disabled={isSubmitting}
                onClick={() => history.goBack()}
              >
                BACK
              </button>
              <button
                type="submit"
                className="form-btns next-btn"
                disabled={isSubmitting}
              >
                NEXT
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MedicalHistory;
